/**
 * Component overrides index.
 * Combines all modern component overrides.
 */

import type { Theme } from '@mui/material/styles';
import type { Skin } from '../../@core/types';

import button from './button';
import card from './card';
import input from './input';
import chip from './chip';
import typography from './typography';
import paper from './paper';
import iconButton from './icon-button';
import list from './list';
import menu from './menu';
import drawer from './drawer';
import table from './table';
import alert from './alert';
import badges from './badges';
import tablePagination from './table-pagination';
import avatar from './avatar';
import select from './select';
import autocomplete from './autocomplete';
import pagination from './pagination';
import breadcrumbs from './breadcrumbs';
import formControlLabel from './form-control-label';

/**
 * Component overrides function
 * @param skin - Skin type (default or bordered)
 * @returns Component overrides object
 */
const overrides = (skin: Skin): Theme['components'] => {
  return Object.assign(
    {},
    button,
    card(skin),
    input,
    chip,
    typography,
    paper,
    iconButton,
    list,
    menu(skin),
    drawer(skin),
    table,
    alert,
    badges,
    tablePagination,
    avatar,
    select,
    autocomplete,
    pagination,
    breadcrumbs,
    formControlLabel
  );
};

export default overrides;
